var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonaco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C31.0459 39.9999 40.0002 31.0456 40.0002 19.9999C40.0002 8.95421 31.0459 -9.15527e-05 20.0002 -9.15527e-05C8.95449 -9.15527e-05 0.000183105 8.95421 0.000183105 19.9999C0.000183105 31.0456 8.95449 39.9999 20.0002 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000183105 19.9999C0.000183105 8.95428 8.95456 -9.15527e-05 20.0002 -9.15527e-05C31.0458 -9.15527e-05 40.0002 8.95428 40.0002 19.9999",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonaco);
export default __webpack_public_path__ + "static/media/monaco.087e44f9e8af69719556979223472812.svg";
export { ForwardRef as ReactComponent };